import { useQuery } from '@tanstack/react-query';
import { QUERY_KEYS } from '../constants';
import { API_ROUTES } from '../constants/apiRoutes';
import { getData } from '../utils/api';

type CryptoExchangeRateResponse = {
  baseCurrency: string;
  targetCurrency: string;
  rate: number;
};

export const useCryptoExchangeRate = (baseCurrency: string, targetCurrency = 'USDT') => {
  const isConversionNeeded = baseCurrency !== targetCurrency;

  return useQuery<CryptoExchangeRateResponse>({
    queryKey: [QUERY_KEYS.cryptoExchangeRate, baseCurrency, targetCurrency],
    queryFn: () => getData(API_ROUTES.CRYPTO.EXCHANGE_RATE, { baseCurrency, targetCurrency }, 'wallet'),
    enabled: isConversionNeeded,
    refetchOnWindowFocus: true,
  });
};
